import React from "react";
import { languages } from "../../constants/languages";
import { withTheme } from "@material-ui/core/styles";
import PictureIcon from "@material-ui/icons/Photo";
import DiaPhotoDialog from "../../components/settings/slideshow/DiaPhotoDialog";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import UpgradeDialog from "../../components/UpgradeDialog";
import Button from "@material-ui/core/Button";
import {
  getFileTooLargeMessage,
  getUploadErrorMessage,
} from "../../util/uploadErrors";

class EditPictureContainer extends React.Component {
  state = {
    dialogOpen: false,
    title: this.props.picture ? this.props.picture.title || "" : "",
    pictureURL: this.props.picture ? this.props.picture.url || "" : "",
    errorMessage: "",
    upgradeDialogOpen: false,
    warningSVG: false,
  };

  toggleUpgradeDialog = () => {
    if (!this.state.upgradeDialogOpen) {
      if (window.firebase.analytics) {
        window.firebase.analytics().logEvent("paywall_public_website_photo");
      }
      // mailer lite paywall seen
      window.firebase
        .firestore()
        .collection("paywallSeenRequests")
        .doc()
        .set({ uid: this.props.user.uid });
    }
    this.setState({ upgradeDialogOpen: !this.state.upgradeDialogOpen });
  };

  toggleDialog = () => {
    this.setState({ dialogOpen: !this.state.dialogOpen });
  };

  handleTitleChange = (e) => {
    this.setState({ title: e.target.value });
  };

  handleUploadStart = () => {
    this.setState({
      isUploading: true,
      errorMessage: "",
    });
  };

  handleProgress = (progress) => {
    this.setState({ progress });
  };

  handleUploadError = (error) => {
    this.setState({ isUploading: false });
    let toUpdate = { errorMessage: getUploadErrorMessage(error, 3) };

    this.setState(toUpdate);
  };

  handleUploadSuccess = (filename) => {
    this.setState({ isUploading: false });

    const storageRef = this.getStorageRef();
    storageRef
      .child(filename)
      .getDownloadURL()
      .then((url) => {
        storageRef
          .child(filename)
          .getMetadata()
          .then((metadata) => {
            const uploadedFileSize = parseInt((metadata || {}).size || "0", 10);
            if (uploadedFileSize > 3 * 1024 * 1024) {
              this.setState({
                errorMessage: getFileTooLargeMessage(3),
                pictureURL: "",
              });
              storageRef.child(filename).delete().catch(() => {});
              return;
            }
            let warningSVG = false;
            if (metadata.contentType === "image/svg+xml") {
              warningSVG = true;
            }
            this.setState({ pictureURL: url, warningSVG: warningSVG });
            // let toUpdate = {};
            // window.firebase
            //   .firestore()
            //   .collection("tournaments")
            //   .doc(this.props.tournament[".key"])
            //   .collection("pictures")
            //   .doc(this.props.picture.id)
            //   .update(toUpdate);
          });
      });
  };

  getStorageRef = () => {
    return window.firebase
      .app()
      .storage("gs://tournament-uploads/")
      .ref(
        "attachments/" +
          this.props.user.uid +
          "/" +
          this.props.tournament[".key"]
      );
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.toggleDialog();
    let toUpdate = {
      url: this.state.pictureURL,
      title: this.state.title,
      num:
        this.props.pictures.length === 0
          ? 0
          : this.props.pictures[this.props.pictures.length - 1].num + 1,
    };
    let picturesRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("pictures");

    let pictureRef = picturesRef.doc();
    if (this.props.picture) {
      pictureRef = picturesRef.doc(this.props.picture.id);
      toUpdate["num"] = this.props.picture.num;
    }

    pictureRef.set(toUpdate).then(() => {
      if (!this.props.picture) {
        this.setState({ title: "", pictureURL: "", errorMessage: "" });
      }
    });
  };

  render() {
    let allowedToUpload = false;
    if (
      this.props.tournamentStatus.status === 1 ||
      this.props.tournamentStatus.status === 2 ||
      this.props.tournamentStatus.status === 3 ||
      this.props.userStatus.status === 1 ||
      this.props.userStatus.status === 2 ||
      this.props.userStatus.status === 3
    ) {
      allowedToUpload = true;
    }

    return (
      <div>
        <DiaPhotoDialog
          open={this.state.dialogOpen}
          title={this.state.title}
          toggleDialog={this.toggleDialog}
          handleTitleChange={this.handleTitleChange}
          handleSubmit={this.handleSubmit}
          handleUploadStart={this.handleUploadStart}
          handleProgress={this.handleProgress}
          handleUploadError={this.handleUploadError}
          handleUploadSuccess={this.handleUploadSuccess}
          dia={this.props.dia}
          storageRef={this.getStorageRef()}
          errorMessagePhoto={this.state.errorMessage}
          allowedToUpload={true}
          photoURL={this.state.pictureURL}
          titleRequired={true}
          warningSVG={this.state.warningSVG}
          tournament={this.props.tournament}
          maxFileSizeMb={3}
          pictureDescriptionText={languages.attachments.descriptionPictures}
          isUploading={this.state.isUploading}
        />
        <UpgradeDialog
          open={this.state.upgradeDialogOpen}
          toggleDialog={this.toggleUpgradeDialog}
          title={languages.upgrade.upgradeTournament}
          description={languages.upgrade.upgradeTextDesign}
          tournament={this.props.tournament}
          user={this.props.user}
          userData={this.props.userData}
          tournamentStatus={this.props.tournamentStatus}
        />

        {this.props.picture ? (
          <IconButton
            aria-label="Change"
            onClick={
              allowedToUpload ? this.toggleDialog : this.toggleUpgradeDialog
            }
            style={{
              height: 30,
              width: 30,
              marginLeft: 5,
              marginRight: 5,
            }}
          >
            <CreateIcon
              style={{
                height: 20,
                width: 20,
                position: "absolute",
                top: 6,
              }}
            />
          </IconButton>
        ) : (
          <Button
            fullWidth
            variant="outlined"
            component="span"
            onClick={
              allowedToUpload ? this.toggleDialog : this.toggleUpgradeDialog
            }
          >
            <PictureIcon style={{ height: 16, width: 16, marginRight: 5 }} />
            {languages.attachments.addPicture}
          </Button>
        )}
      </div>
    );
  }
}

export default withTheme(EditPictureContainer);
